// import PrintActions from '../../../actions/PrintActions';
import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';

// import { endPoints as EndPoints } from '../../../constants/PosConstants';

class PrintLabel extends React.Component {

    constructor(props) {
        super(props);

        // this.state = {
        //     labels : PosStore.getState().labels,
        //     selectedLabel : ''
        // }

        this.printManifest = this.printManifest.bind(this);
    }

    printManifest() {
        var url = ConfigStore.getState().printManifest+'SessionID='+UserStore.getApiData().sessionId+'&ShipID='+this.props.item.PosId;

        window.open(url, '', 'toolbar=0,menubar=0,resizable=0,scrollbars=0,height=10,width=10,top=10,left=10');

        NotificationActions.addNotification({type : 'success', body : 'Manifest printed' });
    }

    render() {
        // var disableSubmit = this.state.selectedLabel.length === 0 ? true : false;
        // var labels = this.state.labels;

        return (


            <div
                className='btn-green transaction__return'
                onClick={this.printManifest}>

                Print Manifest
            </div>

        );
    }
}

export default PrintLabel;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/PrintManifest.react.jsx